export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14610.80f3ee5c.jpg";